import { AccessControl } from "@careinfo/permission-required";
import { tw } from "@careinfo/tailwind";
import {
  ColumnDef,
  flexRender,
  getCoreRowModel,
  getPaginationRowModel,
  Table,
  useReactTable,
} from "@tanstack/react-table";
import { Fragment, useState } from "react";

export default function TableBody({
  table,
  onRowClick,
}: {
  table: Table<any>;
  onRowClick?: (row: any) => void;
}) {
  return (
    <tbody>
      <Rows table={table} onRowClick={onRowClick} />
    </tbody>
  );
}

function Rows({
  table,
  onRowClick,
}: {
  table: Table<any>;
  onRowClick?: (row: any) => void;
}) {
  return (
    <>
      {table.getRowModel().rows.map((row) => (
        <tr
          key={row?.original?.id}
          data-id={row?.original?.id}
          className={tw`even:bg-gray-50 odd:bg-white hover:bg-gray-100 hover:transition-all cursor-pointer`}
          onClick={() => onRowClick && onRowClick(row)}
        >
          {row.getVisibleCells().map((cell) => (
            <td key={row?.original?.id} className={tw`py-2 text-left px-5 `}>
              <div onClick={(e) => e.stopPropagation()}></div>
              {flexRender(cell.column.columnDef.cell, cell.getContext())}
            </td>
          ))}
        </tr>
      ))}
    </>
    //    <>
    //   {table.getRowModel().rows.map((row) => (
    //     <AccessControl
    //       key={row?.original?.id}
    //       allowedPermissions={["can_edit_purchase"]}
    //     >
    //       <tr
    //         data-id={row?.original?.id}
    //         className={tw`
    //           even:bg-gray-50 odd:bg-white hover:bg-gray-100 hover:transition-all
    //           cursor-pointer
    //         `}
    //         onClick={() => onRowClick && onRowClick(row)}
    //       >
    //         {row.getVisibleCells().map((cell) => (
    //           <td key={cell.id} className={tw`py-2 text-left px-5`}>
    //             <div onClick={(e) => e.stopPropagation()}>
    //               {flexRender(cell.column.columnDef.cell, cell.getContext())}
    //             </div>
    //           </td>
    //         ))}
    //       </tr>
    //     </AccessControl>
    //   ))}
    // </>
  );
}

export function TableBodyParent({
  table,
  columns,
}: {
  table: Table<any>;
  columns: ColumnDef<any>[];
}) {
  const [expandedRows, setExpandedRows] = useState<Record<string, boolean>>({});

  const toggleExpand = (rowId: string) => {
    setExpandedRows((prev) => ({
      ...prev,
      [rowId]: !prev[rowId],
    }));
  };

  return (
    <tbody>
      {table.getRowModel().rows.map((row) => (
        <Fragment key={row?.original?.id}>
          <tr
            className={tw`text-primary text-left font-medium cursor-pointer `}
            onClick={() => toggleExpand(row.original.id)}
          >
            {row.getVisibleCells().map((cell) => (
              <td className={tw`py-2 px-5`} key={cell.id}>
                {flexRender(cell.column.columnDef.cell, cell.getContext())}
              </td>
            ))}
          </tr>
          {expandedRows[row.original.id] && (
            <tr>
              <td colSpan={columns.length}>
                <table className={tw`w-full`}>
                  <tbody>
                    <SubRow data={row.original.children} columns={columns} />
                  </tbody>
                </table>
              </td>
            </tr>
          )}
        </Fragment>
      ))}
    </tbody>
  );
}

function SubRow({
  data = [],
  columns,
}: {
  data: Record<string, any>[];
  columns: ColumnDef<any>[];
}) {
  const subTable = useReactTable({
    data,
    columns,
    enableRowSelection: true,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
  });

  return <Rows table={subTable} />;
}

